import dayjs from "dayjs";
import { number, object } from "yup";

import { DiscountTypeEnum } from "@/features/shared";

export const DEFAULT_VALUES = {
  transactionDate: dayjs(),
  buyer: "",
  salesOrderLensProducts: [],
  salesOrderProductVariants: [],
  lensProducts: [],
  paymentTerm: null,
  note: "",
  discountInput: 0,
  discountType: DiscountTypeEnum.FIXED_AMOUNT,
  taxable: false,
  totalIncludesTax: false,
  taxPercentage: 11,
  subtotal: 0,
};

export const VALIDATION_SCHEMA = object().shape({
  buyer: object().nullable().required("Harus diisi"),
  warehouse: object().nullable().required("Harus diisi"),
  paymentTerm: object().nullable().required("Harus diisi"),
  // `discountInput` is the raw user entry: a percent (0-100) when the type is
  // percentage, otherwise a rupiah amount that cannot exceed the subtotal.
  discountInput: number()
    .transform((value, original) =>
      String(original).trim() === "" ? 0 : value
    )
    .min(0, "Diskon tidak boleh kurang dari 0")
    .when("discountType", {
      is: DiscountTypeEnum.PERCENTAGE,
      then: (schema) => schema.max(100, "Diskon persentase maksimal 100%"),
      otherwise: (schema) =>
        schema.test(
          "not-exceed-subtotal",
          "Diskon tidak boleh melebihi subtotal",
          function (value) {
            return (value || 0) <= (this.parent.subtotal || 0);
          }
        ),
    }),
});
